import * as types from '../actions/actionTypes';
import initialState from './initialState';
        
export default function regionReducer(state= initialState.region, action){
    let newState;
	switch(action.type){
         case types.LOAD_REGION_LIST_SUCCESS:		
            action.region.filtroActivo=state.filtroActivo;
            action.region.filtroActual=state.filtroActual;
            action.region.showActivos=state.showActivos;
			 action.region.paginaActual=action.region.pageable.pageNumber;
			 action.region.registrosPorPagina=action.region.size;
            
            return action.region;

        case types.BORRAR_REGION_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(region => region.id !== action.region.id)];          
			return newState;    
            
        case types.ACTIVAR_REGION_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(region => region.id !== action.region.id)];          
			 return newState;
            
        case types.SET_FILTRO_REGION:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}